import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { Popover } from 'primeng/popover';
import { toggleEllipsisPopover } from 'src/app/modules/crm/shared/utilities/ellipsis-popover.util';
import { buttonStatus } from '../../shared/constants/button-class';
import { ellipsisOptions } from '../../shared/constants/ellipsis-options';

@Component({
  standalone: false,
  selector: 'resolution',
  templateUrl: 'resolution.template.html',
  styleUrls: ['resolution.scss'],
})
export class ResolutionComponent implements OnInit {
  selectedItem: any;
  btnStatus: any = buttonStatus;
  options: any[] = ellipsisOptions;
  selectedEllipsisItem: any;

  ngOnInit() {
    this.options = [
      { label: 'Add', value: 'add' },
      { label: 'Update', value: 'update' },
    ];
  }
  selectItem(event, item, Popover: Popover) {
    this.selectedItem = item;
    toggleEllipsisPopover(event, Popover);
  }
  handleClose(event) {
    // TODO: Close event
  }
  handleChange(event) {
    // TODO: Change event
  }
}
